// src/services/auth.js

// Onde guardamos o usuário no localStorage
export const KEY = "ec_user";
const LEGACY_KEY = "usuarioLogado"; // chave antiga (para limpar)

function cleanupLegacy() {
  try { localStorage.removeItem(LEGACY_KEY); } catch {}
}

/** Lê o usuário logado do localStorage */
export function getUser() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/** Verdadeiro se existir usuário válido salvo */
export function isLoggedIn() {
  return !!getUser();
}

/** Salva o usuário (ex.: após login) e notifica a UI */
export function setUser(user) {
  try {
    localStorage.setItem(KEY, JSON.stringify(user));
    cleanupLegacy();
  } catch {}
  // Notifica componentes interessados (ex.: header) sem recarregar a página
  try {
    window.dispatchEvent(new Event("auth-changed"));
  } catch {}
}

/** Remove usuário (logout) e notifica a UI */
export function clearUser() {
  try {
    localStorage.removeItem(KEY);
    cleanupLegacy();
  } catch {}
  try {
    window.dispatchEvent(new Event("auth-changed"));
  } catch {}
}

/** Alias semântico para logout */
export function logout() {
  clearUser();
}
